import {memo, useEffect} from 'react';
import cn from 'classnames';

import styles from './ListTabs.module.scss';
import {OnsiteWorkerScreenTabs} from '../useTeams';

interface Tab {
  title: string;
  value: OnsiteWorkerScreenTabs; // must be mandatory
}

interface Props {
  className?: string;
  tabs: Tab[];
  tab?: OnsiteWorkerScreenTabs;

  activeTabValue?: string;
  onChange: (nextTabValue: OnsiteWorkerScreenTabs) => void;
}

function ListTabs({
  className,
  tab = 'workers_tab',
  tabs,
  activeTabValue,
  onChange,
}: Props) {
  useEffect(() => {
    sessionStorage.setItem(tab, activeTabValue || '');
  }, [activeTabValue, tab]);

  return (
    <div className={cn(styles.root, className)}>
      {tabs.map((tab) => {
        return (
          <span
            key={tab.title}
            className={cn(styles.tab, {
              [styles['--active']]: tab.value === activeTabValue,
            })}
            onClick={() => {
              onChange(tab.value);
            }}
          >
            {tab.title}
          </span>
        );
      })}
    </div>
  );
}

export default memo(ListTabs);
